export const adminhost = "dev.home.alpharepservice.com";
export const superadminhost = "dev.admin.alpharepservice.com";
export const staginghost = "dev.alpharepservice.com";
export const marketinghost = "dev.alpharepservice.com"
